<div class="mt--100 data-table">
  <div class="block saved-payment-methods">
    <h3>Saved Payment Methods</h3>
    <p class="mt--050">Choose one of your saved methods to be the default for future payments</p>

    <div *ngIf="{ value: defaultPaymentMethodId$ | async } as defaultPaymentMethodId" class="mt--150">
      @let cardValidationErrorMessagesMap = cardValidationErrorMessagesMap$ | async;
      <div
        *ngFor="let cardPaymentMethod of savedCardPaymentMethods$ | async"
        class="mt--050 grid-row grid-row--nog grid-row--aic"
        [ngClass]="{ 'disabled': !!cardValidationErrorMessagesMap[cardPaymentMethod.id] }"
      >
        <div class="grid-col grid-col--auto">
          <div class="form-radio">
            <input
              type="radio"
              name="radio"
              [checked]="defaultPaymentMethodId.value === cardPaymentMethod.id"
              [disabled]="!!cardValidationErrorMessagesMap[cardPaymentMethod.id]"
              [value]="cardPaymentMethod.id"
              class="form-radio__input"
              (click)="setPaymentMethodAsDefault(cardPaymentMethod.id, 'CARD')"
              data-cy="saved-payment-radio"
            >
            <span class="form-radio__icon"></span>
          </div>
        </div>

        <div class="grid-col">
          <div class="saved-payment-methods__item">
            <div class="grid-row grid-row--smg grid-row--aic">
              <div class="grid-col grid-col--auto">
                <img [src]="'assets/payment-methods/' + cardPaymentMethod.brand + '.svg'" width="20" height="20" alt="">
              </div>

              <div
                class="grid-col tt--capitalize tc--darkest"
                [ngClass]="{ 'tc--body': !!cardValidationErrorMessagesMap[cardPaymentMethod.id] }"
              >
                {{ PAYMENT_METHOD_BRAND_DISPLAY[cardPaymentMethod.brand] }}

                <ng-container *ngIf="!!cardValidationErrorMessagesMap[cardPaymentMethod.id]">
                  <span class="p p--xs tc--primary">({{ cardValidationErrorMessagesMap[cardPaymentMethod.id][0] }})</span>
                </ng-container>

                <span *ngIf="defaultPaymentMethodId.value === cardPaymentMethod.id" class="p p--xs tc--primary">
                  (Default)
                </span>
              </div>

              <div class="grid-col grid-col--auto grid-col--xs-12 fw--300 tc--xxdark">
                Exp {{ cardPaymentMethod.expirationMonth }} / {{ cardPaymentMethod.expirationYear }}&nbsp;••••&nbsp;{{ cardPaymentMethod.lastFour }}
              </div>
            </div>
          </div>
        </div>

        <div class="grid-col grid-col--auto">
          <button
            type="button"
            class="button button--text"
            (click)="removePaymentMethod(false, cardPaymentMethod.id)"
            data-cy="remove-payment-method"
          >
            <svg
              viewBox="0 0 24 24"
              width="16"
              height="16"
              stroke="currentColor"
              stroke-width="2"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="button__icon"
            >
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              <line x1="10" y1="11" x2="10" y2="17"></line>
              <line x1="14" y1="11" x2="14" y2="17"></line>
            </svg>
          </button>
        </div>
      </div>

      <div *ngFor="let achPaymentMethod of savedAchPaymentMethods$ | async" class="mt--050 grid-row grid-row--nog grid-row--aic">
        <div class="grid-col grid-col--auto">
          <div class="form-radio">
            <input
              type="radio"
              name="radio"
              [checked]="defaultPaymentMethodId.value === achPaymentMethod.id"
              [value]="achPaymentMethod.id"
              class="form-radio__input"
              (click)="setPaymentMethodAsDefault(achPaymentMethod.id, 'ACH')"
              data-cy="saved-payment-radio"
            >
            <span class="form-radio__icon"></span>
          </div>
        </div>

        <div class="grid-col">
          <div class="saved-payment-methods__item">
            <div class="grid-row grid-row--smg grid-row--aic">
              <div class="grid-col grid-col--auto">
                <img src="assets/payment-methods/union.svg" width="20" height="16" alt="">
              </div>
              <div class="grid-col grid-col--auto tt--capitalize tc--darkest bank_transfer_text">
                {{ (achPaymentMethod.type ?? 'ach') | uppercase }} Bank Transfer
                <span *ngIf="defaultPaymentMethodId.value === achPaymentMethod.id" class="p p--xs tc--primary">
                  (Default)
                </span>
              </div>
              <div class="grid-col"></div>
              <div class="grid-col grid-col--auto grid-col--xs-12 fw--300 tc--xxdark">
                {{ achPaymentMethod.brand }}&nbsp;••••&nbsp;{{ achPaymentMethod.lastFour }}
              </div>
            </div>
          </div>
        </div>

        <div class="grid-col grid-col--auto">
          <!-- Remove payment method -->
          <button
            type="button"
            class="button button--text"
            (click)="removePaymentMethod(true, achPaymentMethod.id)"
            data-cy="remove-payment-method"
          >
            <svg
              viewBox="0 0 24 24"
              width="16"
              height="16"
              stroke="currentColor"
              stroke-width="2"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="button__icon"
            >
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              <line x1="10" y1="11" x2="10" y2="17"></line>
              <line x1="14" y1="11" x2="14" y2="17"></line>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="(savedAchPaymentMethods$ | async)?.length > 0" class="grid-col grid-col--auto disclaimer-message">
      Does your bank have debit blocking security enabled?
      <a class="disclaimer-link" (click)="routeToDebitBlockInfoPage()">Learn how to ensure your payment goes through.</a>
    </div>

    <div class="saved-payment-methods__foot">
      <button
        type="button"
        (click)="openNewPaymentMethodModal()"
        class="text-button"
        data-cy="add-payment-method"
      >+ Add Payment Method</button>
    </div>
  </div>
</div>
